Ext.define('SA.view.RecentListUnselectableLocationGeographicReleaseMessage', {
    alias: 'widget.recent-list-unselectable-location-geographic-release-message',
    extend: 'SA.view.ArrowMenu',

    alignment: 'right',
    baseCls: 'sa-recent-list-unselectable-location-geographic-release-message',
    closeAction: 'hide',
    floating: true,
    track: true,
    width: 460,

    items: [{
        xtype: 'component',
        cls: 'sa-recent-list-unselectable-location-geographic-release-message-text',
        html: 'This is disabled because there is no current data for this location.'
    }]
});